import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Unit } from '../../models/dataref.model';

@Component({
  selector: 'app-form-yield',
  templateUrl: './form-yield.component.html',
  styleUrls: ['./form-yield.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormYieldComponent {
  /**
   * FormGroup to be used with the input fields.
   * Must contain yieldQuantity and yieldUnit
   */
  @Input() formGroup?: UntypedFormGroup;

  @Input() yieldUnits: Unit[] = [];
  @Input() lang? = '';
  @Input() market? = '';
}
